import { customerConstants } from "../actions/constants";

const initState = {
  loading: true,
  error: null,
  customers: [],
  message: null,
  customer: null,
};

const customerReducer = (state = initState, action) => {
  switch (action.type) {
    case customerConstants.GET_ALL_CUSTOMERS_REQUEST:
      state = {
        ...state,
        loading: true,
        error: false,
      };
      break;
    case customerConstants.GET_ALL_CUSTOMERS_SUCCESS:
      const { data, message } = action.payload;
      state = {
        ...state,
        loading: false,
        error: false,
        customers: data,
        message: message,
      };
      break;
    case customerConstants.GET_ALL_CUSTOMERS_FAILURE:
      state = {
        ...state,
        initState,
        error: true,
        loading: false,
        message: action.payload.message,
      };
      break;
    case customerConstants.GET_SINGLE_CUSTOMER_REQUEST:
      state = {
        ...state,
        loading: true,
        error: false,
      };
      break;
    case customerConstants.GET_SINGLE_CUSTOMER_SUCCESS:
      const customerData = action.payload.data;
      state = {
        ...state,
        loading: false,
        error: false,
        customer: customerData,
      };

      break;
    case customerConstants.GET_SINGLE_CUSTOMER_FAILURE:
      state = {
        ...state,
        initState,
        error: true,
        loading: false,
        message: action.payload.message,
      };
      break;
    default:
      return state;
    case customerConstants.EDIT_CUSTOMER_REQUEST:
      state = {
        ...state,
        loading: true,
        error: false,
      };
      break;
    case customerConstants.EDIT_CUSTOMER_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: false,
        message: action.payload.message,
      };
      break;
    case customerConstants.EDIT_CUSTOMER_FAILURE:
      state = {
        ...state,
        initState,
        error: true,
        loading: false,
        message: action.payload.message,
      };
      break;
  }
  return state;
};

export default customerReducer;
